import { Space, Card, Collapse } from "antd";
import React, { useEffect } from "react";

import styles from "./ParquetFileForm.module.scss";

import { getParquetFileLink } from "../../../../api/export/export";
import { useUserData } from "../../../../hooks/useUserProfile";
import { Description } from "../../../Description";
import { InputWithCopy } from "../../../FormFields/InputWithCopy/InputWithCopy";

const reportIdentifiers = [
  { value: "IssueSummary", label: "Issue Summary" },
  { value: "MilestoneSummary", label: "Milestone Summary" },
  { value: "ProjectSummary", label: "Project Summary" },
];

export const ParquetFileForm = () => {
  const items = reportIdentifiers.map(({ value, label }) => {
    return {
      key: value,
      label,
      children: <ParquetFileFormItem reportIdentifier={value} />,
    }
  });

  return (
    <Card
      className={styles.card}
      title={
        <div className={styles.cardTitle}>
          Export data to Parquet file
        </div>
      }
    >
      <Space direction="vertical" size={16} className={styles.wrapper}>
        <Collapse items={items} />
        <Description theme={"t4"}>
          This form allows user to generate a link to their data in Parquet
          format. The link will be displayed in a text input field where the
          user can easily copy it. The copied link can then be pasted into Power
          BI to pull the data directly from Friday Report. This functionality
          simplifies the process of integrating data from Friday Report into
          Power BI for further analysis and visualization.
        </Description>
      </Space>
    </Card>
  );
};

interface ParquetFileFormItemProps {
  reportIdentifier: string;
  className?: string;
}

const ParquetFileFormItem: React.FC<ParquetFileFormItemProps> = ({ reportIdentifier }) => {
  const [url, setUrl] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const { organizationId, tenantId } = useUserData();

  const generateLink = async () => {
    setLoading(true);
    const { data } = await getParquetFileLink(organizationId, tenantId, reportIdentifier);
    setUrl(data.data);
    setLoading(false);
  };
  
  useEffect(() => {
    generateLink();
  }, []);

  return <InputWithCopy initialValue={url} disableEditing loading={loading} />;
}